import * as THREE from 'three';
import { PhysicsWorld } from '../physics/PhysicsWorld';
import { ProjectilePool } from '../weapons/ProjectilePool';
import { WeaponManager } from '../weapons/WeaponManager';

export interface GameModeContext {
  scene: THREE.Scene;
  physicsWorld: PhysicsWorld;
  projectilePool: ProjectilePool;
  weaponManager: WeaponManager;
  playerMesh: THREE.Object3D;
  getPlayerPosition: () => THREE.Vector3;
}

export abstract class GameMode {
  protected context: GameModeContext;
  protected isActive: boolean = false;

  constructor(context: GameModeContext) {
    this.context = context;
  }

  public abstract getName(): string;

  public start(): void {
    this.isActive = true;
    this.onStart();
  }

  public stop(): void {
    this.isActive = false;
    this.onStop();
  }

  public abstract update(dt: number): void;

  protected abstract onStart(): void;
  protected abstract onStop(): void;

  public isRunning(): boolean {
    return this.isActive;
  }
}
